/**
 * While the phone bottom bar is drawn, DashboardLayout publishes its height under this name
 * on <html>. Every other element fixed to the bottom of the screen sits above the bar with the
 * class `bottom-[var(--phone-bar-height,0px)]` (the variable is unset, so 0, wherever there is
 * no bar). Tailwind reads class names as text, so the name is repeated in those classes and
 * tests keep them equal to this constant.
 *
 * Only `fixed` elements use the variable. A `sticky` element inside the page area
 * (`main.dashboard-main`) uses `bottom-0`: main already reserves the bar with its own bottom
 * padding, and a sticky inset is measured inside that padding, so the variable would count the
 * bar twice and lift the element above the bar by its height.
 */
export const PHONE_BAR_HEIGHT_VAR = "--phone-bar-height";

/** The bar's row (4rem, the h-16 of the list in phone-bottom-bar.tsx) plus the device's home-indicator space. */
export const PHONE_BAR_HEIGHT = "calc(4rem + env(safe-area-inset-bottom))";
